import { Field } from "redux-form";
import React from "react";

import "./QrFormSection.css";

export const QrFormSection = (props) => {
	return (
		<div className="qr-form-section">
			<div className="qr-form-header">
				<h3 className="qr-form-title">{props.formTitle}</h3>
			</div>
			<div className="qr-form-body">
				<div className="qr-form-form">
					{props.formFields.map((field) => {
						return (
							<Field
								{...field}
								key={field.name}
								readOnly={props.readOnly}
								disabled={props.readOnly}
						  />
					  );
					})}
				</div>
			</div>
		</div>
	);
};

QrFormSection.displayName = "QrFormSection";
